import { EmptyState } from 'src/common/primitives/EmptyState/EmptyState';

export function PaymentLinksEmptyState() {
  return (
    <EmptyState
      description="No payment links found"
      entityName=""
      Icon={<div />}
    />
  );
}
